import request from '@/utils/request'
import config from '@/config'
export default {
  // 得到乡镇站点雨量信息
  getTownRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetTownRain', { params })
  },
  // 水库超汛限
  getResOverflow (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflowWarningWater', { params })
  },
  // 雨量超警
  getWaterOverflow (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflowWarningRain', { params })
  },
  // 预警村落
  getWarnVillage (params) {
    return request.get(config.ApiYJ + '/WarnRecord/WarnVillage', { params })
  },
  // 查询梅雨季节降雨信息
  getRainlySeasonRainfall (params) {
    return request.get(config.ApiYJ + '/RainWater/GetRainlySeasonRainfall', { params })
  },
  // 测站操作
  getProjectGates (params) {
    return request.get(config.ApiYJ + '/HydrologyCenter/GetProjectGates', { params })
  },
  getAnalyticalRain (params) {
    return request.get(config.ApiYJ + '/RainWater/GetAnalyticalRain', { params })
  },
  saveOneRainWaterNotice (params) {
    return request.post(config.ApiYJ + '/intelligentdocument/save_one_rain_water_notice', params)
  }
}
